/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled from "styled-components";
import Colors from 'constants/Colors';
import { FontWeight } from 'components/Text';
import { Breakpoints } from "constants/Breakpoints";

export  const BoxItems = styled.div`
  display:flex;
  padding-right: 10px;
  padding-top: 15px;
  padding-bottom: 15px;
  padding-left: 12px;
  
  `;

  export const TextArea = styled.textarea`
width:100%;
height: 120px;
padding:15px;
border:2px solid ${Colors.GRAY[3]};
border-radius:8px;
resize:none;
font-family: Courier, monospace;
font-weight: ${FontWeight.SemiBold};
color: ${Colors.GRAY[6]};
font-size:14px;
`;

export const Text = styled.text`
  color: ${Colors.GRAY[6]};
  font-weight: ${FontWeight.SemiBold};
  text-transform: uppercase;
  font-size: 16px;
  cursor: pointer;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction:row;
  justify-content: space-between;
  align-items:center;
  margin-top: 20px;
  width: 100%;
  padding: 0px 20px 0px 0px;
`;
  
  
  ///////////////Dialog\\\\\\\\\\\\\\

export const DialogSelect = styled.div`
width: 100%;  
margin: 30px 0px 10px 0px;
`;

export const DialogConfirm = styled.button`
width: calc(50% - 10px);
margin-left: 10px;
height: 40px;
background: ${Colors.BLUE};
border: 0px;
border-radius: 5px;
font-weight: 600;
text-transform: uppercase;
color: #fff;
cursor: pointer; 
`;

export const TextArea2 = styled.textarea`
width:100%;
height: 120px;
padding:15px;
border:2px solid ${Colors.GRAY[3]};
border-radius:8px;
resize:none;
font-family: Courier, monospace;
font-weight: ${FontWeight.SemiBold};
color: ${Colors.GRAY[6]};
font-size:14px;
`;

export const DialogCancel = styled.button`
width: calc(50% - 10px);
margin-right: 10px;
height: 40px;
background: ${Colors.GRAY[0]};
border: 0px;
border-radius: 5px;
font-weight: 600;
text-transform: uppercase;
color: #fff;
cursor: pointer;     
`;

export const DialogRejected = styled.button`
width: calc(50% - 10px);
margin-right: 10px;
height: 40px;
background: ${Colors.GRAY[6]};
border: 0px;
border-radius: 5px;
font-weight: 600;
text-transform: uppercase;
color: #fff;
cursor: pointer;     
`;

export const CustomField = styled.div`
div{
  min-height: auto;
  margin-bottom: 0px;
  width: 100%; 
}
.is-approved{
  span{
    color: ${Colors.PURPLE};
  }
}
.is-disabled{
  span{
    color: ${Colors.GRAY[1]}
  }
}
`;


export const ContentAlert = styled.div`
width: 100%;  
margin-top: 20px;
p{
  color: ${Colors.GRAY[1]};
  margin-bottom: 30px;
  margin-top: 0px;
  font-weight: 500;
  font-size: 14px;
}
`;




export const ContentTextarea = styled.div`
width: 100%;  
margin-top: 0px;
margin-bottom: 0px;
p{
  color: ${Colors.GRAY[0]};
  margin-bottom: 5px;
  margin-top: 10px;
  font-weight: 800;
  font-size: 14px;
}
`;

export const UploadFile = styled.input`
  flex: 1;
  display: none;
  border: none;
  width: 100%;

  &:focus {
    outline: transparent;
  }
`;

export const PlaceHolder = styled.label`
  display: block;
  padding: 0.75rem 3.75rem;
  text-transform: uppercase;
  -webkit-letter-spacing: -0.5px;
  -moz-letter-spacing: -0.5px;
  -ms-letter-spacing: -0.5px;
  letter-spacing: -0.5px;
  font-size: 16px;
  height: 42px;
  width: auto;
  white-space: nowrap;
  font-family: "Quicksand";
  font-weight: bold;
  font-style: normal;
  border: 0 none;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
  -webkit-transition: background-color 0.15s ease, color 0.15s ease,
    width 0.3s ease, border 0.5s ease, border-color 0.5s ease,
    box-shadow 0.15s ease;
  transition: background-color 0.15s ease, color 0.15s ease, width 0.3s ease,
    border 0.5s ease, border-color 0.5s ease, box-shadow 0.15s ease;
  text-align: center;
  color: #ffffff;
  background-color: ${Colors.BLUE};
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.1);
`;

export const ButtonContent = styled.div`
  display:flex;
  flex-direction: row;
  background-color:#FFF; 
  justify-content: space-evenly;

  @media (max-width: ${Breakpoints.lg}) {  
    flex-wrap: wrap;
    padding-right: 10px;
    width: 100%;
  }
`;